import _omit from "lodash/omit";
var samplesDelete = function samplesDelete(state, action) {
  var sampleIds = action.payload.sampleIds;
  var updatedObject = null;
  updatedObject = _omit(state, sampleIds);
  return updatedObject;
};
export default samplesDelete;